import dataStoreFactory from '~utils/data-store-factory';
import { UploadsService } from '~modules/features/uploads';

const Uploads = dataStoreFactory(UploadsService);

export default new Uploads();
